<div
  #navBar
  class="container"
  *ngIf="
    this.gradientConfig.layout === 'horizontal' &&
      this.gradientConfig.subLayout === 'horizontal-2';
    else mainHeader
  "
>
  <ng-container *ngTemplateOutlet="mainHeader"></ng-container>
</div>
<ng-template #mainHeader>
  <div [ngClass]="navCollapsed ? 'navbar-collapsed' : 'd-flex'" class="m-header justify-content-center">
    <a
      *ngIf="!isHiddenIconCollapse"
      href="javascript:"
      class="mobile-menu"
      id="mobile-collapse"
      (click)="navCollapse()"
      ><span></span
    ></a>
    <a
      [routerLink]="
        isSubscriptionExpired ? ['/subscriptions', companyId] : ['/dashboard']
      "
      class="b-brand d-flex justify-content-center w-full link-navbar-logo"
    >
      <img
        class="logo-navbar logo-light-navbar"
        src="assets/images/logo-light.svg"
        alt="Inventory Optimizer"
      />

      <img
        class="logo-navbar logo-dark-navbar"
        src="assets/images/logo-dark.svg"
        alt="Inventory Optimizer"
      />
    </a>
    <a
      class="mob-toggler"
      [ngClass]="{ on: this.menuClass }"
      href="javascript:"
      (click)="toggleMobOption()"
      ><i class="feather icon-more-vertical"></i
    ></a>
  </div>
  <div class="collapse navbar-collapse px-4" [style.display]="this.collapseStyle">
    <app-nav-left
      [isSubscriptionExpired]="isSubscriptionExpired"
      class="mr-auto"
    ></app-nav-left>
    <app-nav-right
      [navBarHeight]="navBarHeight"
      [isSubscriptionExpired]="isSubscriptionExpired"
      class="ml-auto"
    ></app-nav-right>
  </div>
</ng-template>
